<template>
  <div class="container">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <label class="form-label">วันที่เริ่ม</label>
        <input v-model="dateFilter.start" type="date" class="form-control">
      </div>

      <div class="col-md-3">
        <label class="form-label">วันที่สิ้นสุด</label>
        <input v-model="dateFilter.end" type="date" class="form-control">
      </div>

      <div class="col-md-6 d-flex align-items-end gap-2 flex-wrap">
        <button class="btn btn-primary" @click="setLast7Days">
          7 วันล่าสุด
        </button>

        <button class="btn btn-secondary" @click="clearDateFilter">
          ล้างตัวกรอง
        </button>
      </div>
    </div>

    <div v-if="type == 1">
      <div class="mb-3 p-3 border rounded bg-light">
        <h5 class="mb-1">
          ประวัติการเดินของผู้เข้าร่วมโครงการ
        </h5>
        <h5 class="mb-1">
          {{ participant.firstname }} {{ participant.lastname }}
        </h5>
        <div class="text-muted">
          รหัสสุ่ม: {{ participant.random_number || '-' }}
        </div>
      </div>

      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>รอบ</th>
            <th>วันที่เริ่ม</th>
            <th>วันที่จบ</th>
            <th>ระยะเวลา</th>
            <th>สถานะ</th>
            <th>วิดีโอเริ่ม</th>
            <th>วิดีโอจบ</th>
            <th>ข้อความหลังจบกิจกรรม</th>
          </tr>

        </thead>
        <tbody>
          <tr v-for="item in sortedData" :key="item.id">
            <td>รอบที่ {{ item.round }}</td>
            <td>{{ formatDate(item.started_at) }}</td>
            <td>{{ formatDate(item.finished_at) }}</td>
            <td>{{ calculateDuration(item.started_at, item.finished_at) }}</td>
            <td>
              <span :class="Number(item.is_success) === 1 ? 'text-success' : 'text-danger'">
                {{ Number(item.is_success) === 1 ? 'สำเร็จ' : 'ไม่สำเร็จ' }}
              </span>
            </td>
            <td>
              <button v-if="item.start_record_path" @click="openVideo(item.start_record_path)"
                class="btn btn-sm btn-primary">
                ดูวิดีโอเริ่ม
              </button>
              <span v-else>-</span>
            </td>
            <td>
              <button v-if="item.end_record_path" @click="openVideo(item.end_record_path)"
                class="btn btn-sm btn-success">
                ดูวิดีโอจบ
              </button>
              <span v-else>-</span>
            </td>
            <td colspan="8" class="bg-light">
              {{ item.after_message || '-' }}
            </td>
          </tr>

          <tr v-if="sortedData.length === 0">
            <td colspan="8" class="text-center text-muted">
              ไม่พบข้อมูลในช่วงวันที่เลือก
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="type == 2">
      <div class="mb-3 p-3 border rounded bg-light">
        <h5 class="mb-1">
          ประวัติการบีบมือของผู้เข้าร่วมโครงการ
        </h5>
        <h5 class="mb-1">
          {{ participant.firstname }} {{ participant.lastname }}
        </h5>
        <div class="text-muted">
          รหัสสุ่ม: {{ participant.random_number || '-' }}
        </div>
      </div>

      <div v-for="group in groupedHandHistoryByDate" :key="group.groupKey" class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-start">
          <div>
            <strong>วันที่ {{ formatGroupDate(group.displayDate) }}</strong>
            <div class="text-muted small">
              จำนวนรอบ {{ group.items.length }} / 4
            </div>
          </div>

          <div class="text-end">
            <span :class="group.isComplete ? 'badge bg-success' : 'badge bg-warning text-dark'">
              {{ group.isComplete ? 'ครบ 4 รอบ' : 'ยังไม่ครบ' }}
            </span>
          </div>
        </div>

        <div class="card-body p-0">
          <table class="table table-bordered table-hover mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>กิจกรรมย่อย</th>
                <th>วันที่เริ่ม</th>
                <th>วันที่จบ</th>
                <th>ระยะเวลา</th>
                <th>สถานะ</th>
                <th>วิดีโอเริ่ม</th>
                <th>วิดีโอจบ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in group.items" :key="item.id">
                <td>{{ item.id }}</td>
                <td>รอบที่ {{ item.set_of_activities }}</td>
                <td>{{ formatDate(item.started_at) }}</td>
                <td>{{ formatDate(item.finished_at) }}</td>
                <td>{{ calculateDuration(item.started_at, item.finished_at) }}</td>
                <td>
                  <span :class="Number(item.is_success) === 1 ? 'text-success fw-bold' : 'text-danger fw-bold'">
                    {{ Number(item.is_success) === 1 ? 'สำเร็จ' : 'ไม่สำเร็จ' }}
                  </span>
                </td>
                <td>
                  <button v-if="item.start_record_path" @click="openVideo(item.start_record_path)"
                    class="btn btn-sm btn-outline-primary">
                    Start
                  </button>
                  <span v-else>-</span>
                </td>
                <td>
                  <button v-if="item.end_record_path" @click="openVideo(item.end_record_path)"
                    class="btn btn-sm btn-outline-success">
                    Finish
                  </button>
                  <span v-else>-</span>
                </td>
              </tr>

              <tr v-if="group.afterMessage">
                <td colspan="8" class="bg-light">
                  <strong>ข้อความหลังจบกิจกรรม:</strong>
                  {{ group.afterMessage }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="groupedHandHistoryByDate.length === 0" class="text-center text-muted border rounded p-4">
        ไม่พบข้อมูลในช่วงวันที่ที่เลือก
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantsActivitiesService from "../services/ParticipantsActivitiesService";
import LinkService from "../services/LinkService";
import ParticipantService from "../services/ParticipantService";

export default {
  name: "Nav",
  props: {
    id: {
      type: Number,
      // required: true
    },
    type: {
      type: Number,
      default: 1
    }
  },
  components: {},
  data() {
    return {
      walkData: [],
      hand: [],
      link: "",
      dateFilter: {
        start: "",
        end: "",
      },
      participant:{}
    };
  },

  mounted() {
    const id = Number(this.$route.params.id || this.id)
    const type = Number(this.$route.params.type || this.type)
    // this.id = id
    // this.type = type
    console.log(id, type, "Participant");
    console.log(this.id, this.type, "this.Participant");
    this.getActivity(this.id, this.type);
    this.link = LinkService.getLink();
    this.getById()
  },
  methods: {
    getById(){
      ParticipantService.getById(this.id).then((res) => {
          // console.log(res.data);
          this.participant = res.data;
        });
  },
    getActivity(id, type) {
      console.log(id,type,'history');
      
      ParticipantsActivitiesService.getByActivity(id, type).then((res) => {
        const rows = Array.isArray(res.data) ? res.data : [];
        if (type == 1) {
          this.walkData = rows
          // console.log(this.walkData);
        } else {
          this.hand = rows
        }
      });
    },

    clearDateFilter() {
      this.dateFilter.start = "";
      this.dateFilter.end = "";
    },

    setLast7Days() {
      const today = new Date()

      // หาวันในสัปดาห์ (0 = Sunday)
      const day = today.getDay()

      // 🔹 อาทิตย์ที่ผ่านมา
      const lastSunday = new Date(today)
      lastSunday.setDate(today.getDate() - day)

      // 🔹 อาทิตย์ถัดไป
      const nextSunday = new Date(lastSunday)
      nextSunday.setDate(lastSunday.getDate() + 7)

      this.dateFilter.start = this.formatInputDate(lastSunday)
      this.dateFilter.end = this.formatInputDate(nextSunday)
    },

    formatInputDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    isInDateRange(dateValue) {
      if (!dateValue || dateValue === "0000-00-00") return false;

      const itemDate = new Date(dateValue);
      if (isNaN(itemDate.getTime())) return false;

      if (!this.dateFilter.start && !this.dateFilter.end) {
        return true;
      }

      const itemOnlyDate = new Date(
        itemDate.getFullYear(),
        itemDate.getMonth(),
        itemDate.getDate()
      );

      if (this.dateFilter.start) {
        const startDate = new Date(this.dateFilter.start);
        const startOnlyDate = new Date(
          startDate.getFullYear(),
          startDate.getMonth(),
          startDate.getDate()
        );

        if (itemOnlyDate < startOnlyDate) return false;
      }

      if (this.dateFilter.end) {
        const endDate = new Date(this.dateFilter.end);
        const endOnlyDate = new Date(
          endDate.getFullYear(),
          endDate.getMonth(),
          endDate.getDate()
        );

        if (itemOnlyDate > endOnlyDate) return false;
      }

      return true;
    },

    formatGroupDate(date) {
      if (!date || date === "0000-00-00") return "-";
      return new Date(date).toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    formatDate(date) {
      if (!date || date === "0000-00-00") return "-";
      return new Date(date).toLocaleString("th-TH");
    },

    calculateDuration(start, end) {
      if (!start || !end) return "-";

      const startedAt = new Date(start);
      const finishedAt = new Date(end);

      const durationSeconds = Math.floor((finishedAt - startedAt) / 1000);
      if (durationSeconds < 0) return "-";

      const minutes = Math.floor(durationSeconds / 60);
      const seconds = durationSeconds % 60;

      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },

    openVideo(path) {
      window.open(this.link + path, "_blank");
    },

    getGroupDateKey(item) {
      if (item.activity_date && item.activity_date !== "0000-00-00") {
        return item.activity_date.slice(0, 10);
      }

      if (item.started_at) {
        const d = new Date(item.started_at);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      return "unknown-date";
    },
  },
  

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    sortedData() {
      return [...this.walkData]
        .filter((item) => this.isInDateRange(item.started_at))
        .sort((a, b) => new Date(b.started_at) - new Date(a.started_at));
    },

    groupedHandHistoryByDate() {
      const filteredHand = this.hand.filter((item) =>
        this.isInDateRange(
          item.activity_date && item.activity_date !== "0000-00-00"
            ? item.activity_date
            : item.started_at
        )
      );

      const grouped = filteredHand.reduce((acc, item) => {
        const groupKey = this.getGroupDateKey(item);

        if (!acc[groupKey]) {
          acc[groupKey] = {
            groupKey,
            displayDate:
              item.activity_date && item.activity_date !== "0000-00-00"
                ? item.activity_date
                : item.started_at,
            items: [],
          };
        }

        acc[groupKey].items.push(item);
        return acc;
      }, {});

      return Object.values(grouped)
        .map((group) => {
          group.items.sort(
            (a, b) => Number(a.set_of_activities) - Number(b.set_of_activities)
          );

          const sets = [...new Set(group.items.map((i) => Number(i.set_of_activities)))].sort(
            (a, b) => a - b
          );

          group.isComplete =
            JSON.stringify(sets) === JSON.stringify([1, 2, 3, 4]);

          const set4 = group.items.find(
            (item) => Number(item.set_of_activities) === 4
          );

          group.afterMessage = set4?.after_message || null;

          return group;
        })
        .sort((a, b) => new Date(b.displayDate) - new Date(a.displayDate));
    },
  },
};
</script>

<style scoped>
a {
  font-size: 12px !important;
}

button {
  font-size: 12px !important;
}

.table th,
.table td {
  vertical-align: middle;
  font-size: 13px;
}

.sidebar {
  margin: 0;
  padding: 0;
  width: 200px;
  background-color: #f1f1f1;
  position: fixed;
  height: 100%;
  overflow: auto;
  font-size: 12px !important;
}

.sidebar a {
  display: block;
  color: black;
  padding: 16px;
  text-decoration: none;
  font-size: 12px !important;
}

.sidebar a.active {
  background-color: #7E51AB;
  color: white;
  font-size: 12px !important;
}

.sidebar a:hover:not(.active) {
  background-color: #B7A1CC;
  color: white;
  font-size: 12px !important;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
    font-size: 12px !important;
  }

  .sidebar a {
    float: left;
    font-size: 12px !important;
  }

  div.content {
    margin-left: 0;
    font-size: 12px !important;
  }
}

@media screen and (max-width: 400px) {
  .sidebar a {
    font-size: 12px !important;
    text-align: center;
    float: none;
  }
}
</style>